import { useParams } from "react-router";
import { DocumentBlobCard } from "@/services/backend/filestorage/components/document-blob-card";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";

export function OrderFilesRoute() {
  const { orderId } = useParams();

  return (
    <DocumentBlobCard
      subdomain={GSMServiceKind.HTZ}
      documentKind={GSMDocumentKind.Order}
      documentId={orderId!}
      accept="application/pdf,image/jpeg,image/png"
    />
  );
}
